/**
Project: Voice Panel (c)
Title: Constants
Description: Constants used for Redux store
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
export const APP_NAME = "APP_NAME";
export const CLIENT_NAVIGATOR = "CLIENT_NAVIGATOR";
export const WHITE_LIST_DOMAINS = "WHITE_LIST_DOMAINS";
